import { useSnapshot } from 'valtio'
import cn from 'classnames'
import format from 'date-fns/format'
import { type ReactElement } from 'react'
import { TableCell } from '../../../../../transactions/index/TransactionsTable/TransactionsRows/TableCell'
import OutlineButton from '../../../../../../../shared/components/ui/buttons/OutlineButton'
import { rpOccurrenceProxy } from '../../rpOccurrenceProxy'
import { buildAppTransactionPath } from '../../../../../../../pages/app/transactions/[id]'
import { PRETTY_TRANSACTION_TYPE } from '../../../../../../../shared/types/GlobalTranactionTypeEnum'
import { AmountCell } from '../../../../../transactions/index/TransactionsTable/AmountCell/AmountCell'
import TransactionStatusLabel from '../../../../../../../shared/components/ui/TransactionStatusLabel'

export function RoOccurrenceRelatedTransactionRows (): ReactElement {
  const { rpOccurrence } = useSnapshot(rpOccurrenceProxy)

  if (!rpOccurrence?.transactions || rpOccurrence.transactions?.length === 0) {
    return (
      <tr>
        <td colSpan={10}>
          <div className="text-center my-16 text-wpy-gray">
            No Results
          </div>
        </td>
      </tr>
    )
  }

  return (
    <>
      {rpOccurrence?.transactions?.map((transaction, i) => {
        const notLastRow = i !== (rpOccurrence?.transactions?.length ?? 0)
        const path = buildAppTransactionPath(transaction.id)
        return (
          <tr
            key={transaction.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell path={path}>
              {transaction.id}
            </TableCell>
            <TableCell path={path}>
              {format(new Date(transaction.transactedAt), 'MMM d, y')}
            </TableCell>
            <TableCell path={path}>
              {rpOccurrence.customerCard?.cardName ?? 'Cash'}
            </TableCell>

            <TableCell path={path}>
              {PRETTY_TRANSACTION_TYPE[transaction.ppSslTransactionType]}
            </TableCell>

            <TableCell path={path}>
              <TransactionStatusLabel status={transaction.status} />
            </TableCell>

            <TableCell path={path}>
              <AmountCell transaction={transaction} />
            </TableCell>

            <TableCell path={path}>
              <OutlineButton additionalClasses="px-12  py-1" clickFunction={() => {}} text="View Details" />
            </TableCell>

          </tr>
        )
      })}
    </>
  )
}
